import {
  LelyBackgroundColorLight,
  LelyTextColorLight,
  LelyBorderColorLight,
  LelyColorMaintenance,
} from '@lely/tokens/enums';

import '@mui/material/styles';

export const text = {
  default: LelyTextColorLight.DEFAULT,
  defaultInverted: LelyTextColorLight.DEFAULT_INVERTED,

  subtle: LelyTextColorLight.SUBTLE,
  subtleInverted: LelyTextColorLight.SUBTLE_INVERTED,

  light: LelyTextColorLight.LIGHT,
  lightInverted: LelyTextColorLight.LIGHT_INVERTED,

  brandPrimary: LelyTextColorLight.BRAND_PRIMARY,
  brandSecondary: LelyTextColorLight.BRAND_SECONDARY,

  advice: LelyTextColorLight.ADVICE,
  warning: LelyTextColorLight.WARNING,
  error: LelyTextColorLight.ERROR,
  success: LelyTextColorLight.SUCCESS,
  information: LelyTextColorLight.INFORMATION,
};
export type LelyTextPalette = typeof text;

export const background = {
  default: LelyBackgroundColorLight.DEFAULT,
  light: LelyBackgroundColorLight.LIGHT,

  brandPrimary: LelyBackgroundColorLight.BRAND_PRIMARY,
  brandSecondary: LelyBackgroundColorLight.BRAND_SECONDARY,

  primaryDefault: LelyBackgroundColorLight.PRIMARY_DEFAULT,
  primaryHover: LelyBackgroundColorLight.PRIMARY_HOVER,
  primaryActive: LelyBackgroundColorLight.PRIMARY_ACTIVE,
  primaryInvertedDefault: LelyBackgroundColorLight.PRIMARY_INVERTED_DEFAULT,
  primaryInvertedHover: LelyBackgroundColorLight.PRIMARY_INVERTED_HOVER,
  primaryInvertedActive: LelyBackgroundColorLight.PRIMARY_INVERTED_ACTIVE,

  secondaryDefault: LelyBackgroundColorLight.SECONDARY_DEFAULT,
  secondaryHover: LelyBackgroundColorLight.SECONDARY_HOVER,
  secondaryActive: LelyBackgroundColorLight.SECONDARY_ACTIVE,
  secondaryInvertedDefault: LelyBackgroundColorLight.SECONDARY_INVERTED_DEFAULT,
  secondaryInvertedHover: LelyBackgroundColorLight.SECONDARY_INVERTED_HOVER,
  secondaryInvertedActive: LelyBackgroundColorLight.SECONDARY_INVERTED_ACTIVE,

  tertiaryDefault: LelyBackgroundColorLight.TERTIARY_DEFAULT,
  tertiaryHover: LelyBackgroundColorLight.TERTIARY_HOVER,
  tertiaryActive: LelyBackgroundColorLight.TERTIARY_ACTIVE,
  tertiaryInvertedDefault: LelyBackgroundColorLight.TERTIARY_INVERTED_DEFAULT,
  tertiaryInvertedHover: LelyBackgroundColorLight.TERTIARY_INVERTED_HOVER,
  tertiaryInvertedActive: LelyBackgroundColorLight.TERTIARY_INVERTED_ACTIVE,

  information: LelyBackgroundColorLight.INFORMATION,
  advice: LelyBackgroundColorLight.ADVICE,
  warning: LelyBackgroundColorLight.WARNING,
  error: LelyBackgroundColorLight.ERROR,
  success: LelyBackgroundColorLight.SUCCESS,
  maintenance: LelyColorMaintenance._40,
};
export type LelyBackgroundPalette = typeof background;

export const border = {
  default: LelyBorderColorLight.DEFAULT,
  subtle: LelyBorderColorLight.SUBTLE,
  light: LelyBorderColorLight.LIGHT,
  focus: LelyBorderColorLight.FOCUS,

  brandPrimary: LelyBorderColorLight.BRAND_PRIMARY,
  brandSecondary: LelyBorderColorLight.BRAND_SECONDARY,

  primaryDefault: LelyBorderColorLight.PRIMARY_DEFAULT,
  primaryHover: LelyBorderColorLight.PRIMARY_HOVER,
  primaryActive: LelyBorderColorLight.PRIMARY_ACTIVE,

  error: LelyBorderColorLight.ERROR,
};
export type LelyBorderPalette = typeof border;

const buildLelyPalette = () => ({
  mode: 'light' as const,

  primary: {
    main: LelyBackgroundColorLight.BRAND_PRIMARY,
  },
  secondary: {
    main: LelyBackgroundColorLight.BRAND_SECONDARY,
  },
  error: {
    main: LelyBackgroundColorLight.ERROR,
  },
  warning: {
    main: LelyBackgroundColorLight.WARNING,
  },
  success: {
    main: LelyBackgroundColorLight.SUCCESS,
  },
  info: {
    main: LelyBackgroundColorLight.INFORMATION,
    subtle: LelyBackgroundColorLight.INFORMATION_SUBTLE,
  },
  divider: LelyBorderColorLight.SUBTLE,
  action: {
    active: LelyBorderColorLight.PRIMARY_HOVER,
    hover: LelyBackgroundColorLight.SECONDARY_HOVER,
    disabledOpacity: 0.32,
  },
  default: {
    main: LelyBackgroundColorLight.SECONDARY_DEFAULT,
  },

  text,
  background,
  border,
});

export default buildLelyPalette;
